import { render, staticRenderFns } from "./individual.vue?vue&type=template&id=7cff49f4&scoped=true&"
import script from "./individual.vue?vue&type=script&lang=js&"
export * from "./individual.vue?vue&type=script&lang=js&"
import style0 from "./individual.vue?vue&type=style&index=0&id=7cff49f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cff49f4",
  null
  
)

export default component.exports